import { ChangeEvent, on } from '@disy/lib/event-util';
import { throttle } from '@disy/lib/throttle';

import { PARAMETER_LAYOUT } from 'cadenza/api-client/api-constants';

export type WorksheetLayout = 'linear' | 'intermediate' | 'dashboard';

export const worksheetLayout = new (class extends EventTarget {
  setup() {
    // do not setup layout management on pages without a d-page e.g. printouts
    if (!document.querySelector<HTMLElement>('.d-page')) {
      return;
    }
    const param = new URLSearchParams(location.search).get(PARAMETER_LAYOUT);
    if (param === 'linear' || param === 'dashboard') {
      this.#setLayout(param);
    } else {
      this.#update();
      on(
        window,
        'resize',
        throttle(() => this.#update()),
      );
    }
  }

  #update() {
    let layout: WorksheetLayout = 'dashboard';
    if (window.innerWidth < 600 || window.innerHeight < 450) {
      layout = 'linear';
    } else if (window.innerWidth < 1000 || window.innerHeight < 600) {
      layout = 'intermediate';
    }
    this.#setLayout(layout);
  }

  #setLayout(layout: WorksheetLayout) {
    if (layout !== this.value) {
      document.documentElement.dataset.worksheetLayout = layout;
      this.dispatchEvent(new ChangeEvent());
    }
  }

  get value() {
    return document.documentElement.dataset.worksheetLayout as WorksheetLayout | undefined;
  }
})();

export function isLinearLayout() {
  return worksheetLayout.value === 'linear';
}

export function isDashboardLayout() {
  return worksheetLayout.value === 'dashboard';
}
